// extracted by mini-css-extract-plugin
export default {"selectBlock":"LandTopicStyle_selectBlock__zvxgZ","littleTitle":"LandTopicStyle_littleTitle__kBRHL","ItemList":"LandTopicStyle_ItemList__-mDn6"};